/**
 * `/admin/perfis` (a tela de lista) ainda é fase 8 — este arquivo serve só
 * `/admin/perfis/:id/usuarios` (ONDA-CA2), que o laudo pede como entrega
 * isolada. Sem tela de lista real ainda, não há de onde puxar perfil de
 * verdade: os dados abaixo são mock local, mesmo padrão de
 * modulos/admin/comunicacao/dadosMock.ts.
 */

export interface PerfilAcessoMock {
  id: string;
  nome: string;
  descricao: string;
}

export interface UsuarioDoPerfilMock {
  userId: string;
  nome: string;
  cargo: string;
  vinculadoEm: string;
}

function diasAtras(d: number): string {
  return new Date(Date.now() - d * 86_400_000).toISOString();
}

export const PERFIS_ACESSO_MOCK: Record<string, PerfilAcessoMock> = {
  'analista-financeiro': {
    id: 'analista-financeiro',
    nome: 'Analista financeiro',
    descricao: 'Acesso de leitura e conciliação em pagamentos e cobranças.',
  },
  'fiscal-dre': {
    id: 'fiscal-dre',
    nome: 'Fiscal de DRE',
    descricao: 'Acompanhamento de ocorrências e penalidades da própria diretoria.',
  },
};

export const USUARIOS_POR_PERFIL_MOCK: Record<string, UsuarioDoPerfilMock[]> = {
  'analista-financeiro': [
    {
      userId: 'u-1',
      nome: 'Marina Costa Exemplo',
      cargo: 'Analista financeiro pleno',
      vinculadoEm: diasAtras(40),
    },
    {
      userId: 'u-2',
      nome: 'Rafael Souza Exemplo',
      cargo: 'Analista financeiro júnior',
      vinculadoEm: diasAtras(12),
    },
    {
      userId: 'u-3',
      nome: 'Bianca Alves Exemplo',
      cargo: 'Coordenadora financeira',
      vinculadoEm: diasAtras(200),
    },
  ],
  'fiscal-dre': [
    {
      userId: 'u-4',
      nome: 'João Pereira Exemplo',
      cargo: 'Fiscal de transporte',
      vinculadoEm: diasAtras(80),
    },
  ],
};
